import { CustomerApi } from "~/api/Customer";

export function useCustomerApi(): CustomerApi {    
  const customerApi = new CustomerApi(useHttpClient());

  return customerApi;
}
